import { render, staticRenderFns } from "./openVip.vue?vue&type=template&id=3d3481f2"
import script from "./openVip.vue?vue&type=script&lang=js"
export * from "./openVip.vue?vue&type=script&lang=js"
import style0 from "./openVip.vue?vue&type=style&index=0&id=3d3481f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports